const servicePlans = ({servicePlan}) => servicePlan.items;
const servicePlansErrors = ({servicePlan}) => servicePlan.errors;

export const selectors = {
    servicePlans,
    servicePlansErrors
};
